import { http } from "@/utils/request";
import type {
  InvitationsResponse,
  GetInvitationsParams,
} from "@/types/invite.types";

export const inviteService = {
  // 获取邀请列表
  getInvitations: async (
    params: GetInvitationsParams
  ): Promise<InvitationsResponse> => {
    return http.get<InvitationsResponse>("/invitation/list", params);
  },

  // 导出邀请列表
  exportInvitations: async (params: GetInvitationsParams): Promise<Blob> => {
    return http.get<Blob>("/invitation/export", params, {
      responseType: "blob",
    });
  },
};
